import type { BillingPeriod } from '@/entities/plan';
import type { PaymentMethod } from '@/entities/payment-method';
import type { EmailFormData } from '@/shared/lib/validation/registration-wizard/email';
import type { ProfileFormData } from '@/shared/lib/validation/registration-wizard/profile';
import type { CompanyFormData } from '@/shared/lib/validation/registration-wizard/company';
import type { SignupCredentialsFormData } from '@/shared/lib/validation/registration-wizard/credentials';
import type { BillingAddressFormData } from '@/shared/lib/validation/registration-wizard/billing-address';


export type SplitWizardStep =
    | 'email'
    | 'profile'
    | 'confirmation_sent'
    | 'company'
    | 'plan'
    | 'payment'
    | 'confirmation';


export type SplitWizardData = {
    billing_address?: BillingAddressFormData;
    company?: CompanyFormData;
    credentials?: SignupCredentialsFormData;
    email?: EmailFormData;
    payment_method?: PaymentMethod;
    payment_method_id?: string;
    plan?: {
        billing_period: BillingPeriod;
        plan_id: string;
    };
    profile?: ProfileFormData;
};


export type SplitWizardState = {
    step: SplitWizardStep;
    data: SplitWizardData;
};


export const getSplitWizardStepNumber = (step: SplitWizardStep, order: SplitWizardStep[]): number => {
    return order.indexOf(step);
};


export const buildSplitWizardInitialState = (
    initialStep: SplitWizardStep,
    initialData: SplitWizardData = {},
): SplitWizardState => ({
    step: initialStep,
    data: initialData,
});
